<template>
  <div class="pageContainer">
    <div class="topDiv backgroundCoverImageCenter">
      <h1>
        How Do We Do
      </h1>
    </div>
    <div class="bottomDiv">
      <div class="container">
      <h4>> Deposit and Full Payment</h4>
      <p>
        A $500/per person deposit and a completed Reservation Form will hold space for you on a trip. The remainder is due 60 days
        prior to the trip departure date.
      </p>
      <h4>> Travel/Cancellation Insurance</h4>
      <p>
        Travel/cancellation insurance is required for our trips. If you need help with your policy, contact Expedition Broker.
      </p>
      <h4>> Air & Lodging Reservations</h4>
      <p>
        We urge you to make your travel plans as early as possible. Airlines, hotels, and bed & breakfasts fill up quickly. See our
        Lodging and Transportation recommendations list. Plan to arrive the day before your trip starts in time to attend
        a mandatory, 4 pm pre-trip meeting. Plan to depart no sooner than the evening following the last day of your trip’s
        published end date.
      </p>
      <h4>> Return from the wilds & Possibility of Delay</h4>
      <p>
        Weather and airline connections permitting, you will return from your trip late in the day on the last day of your trip’s
        published end date. It is a good idea to plan one or more extra days in the area following your return in case of
        delay. Relatives and employers should be made aware of delay possibilities and someone at home should have the ability
        to re-organize your travel and lodging should your delay necessitate a change in plans for you.
      </p>
      <h4>> Pre-trip Meeting</h4>
      <p>
        We will host a pre-trip meeting the evening before your trip. If your trip starts in Fairbanks, rendezvous at the Arctic
        Wild “World Headquarters” on Nash St west of the University at 4 pm.
      </p>
      <p>
      For trips starting in Kotzebue we meet at the Arctic Backcountry Flying Service hangar at 6:30 pm. For other starting locations,
      we will contact you about the meeting location and time.
      </p>
      <p>
        Regardless of location the pre-trip meeting is a meet-and-greet, orientation, and Q&A session all rolled into one! Please
        bring all your gear in backpacks or river bags- all of it– as you intend to carry it. We will weigh it, and help
        winnow it, if necessary. The meeting takes about 2 hours.
      </p>
</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'how_do_we_do'
  /*,
     data () {
       return {}
     } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~scssDir/_breakpoints.scss";
@import "~scssDir/_variables.scss";
@import "~scssDir/_myAnimations.scss";
.topDiv {
  height: 60px;
  background-color: $color5;
  @include media-md{
    height:30vh;
  }
  h1 {
    line-height: 20px;
    color: $color2;
    @include media-md{
      line-height: unset;
    }
  }
}
.bottomDiv {
  height: 70vh;
  background-color: $color4;
  .container {
    h4 {
      margin: 0;
      padding: 10px 0;
      color: $color1;
      line-height:48px;
      font-weight:700;
    }
    p {
      margin: 0;
      padding-left: 10px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/how_do_we_do.vue